import React, { useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import get from "lodash/get";
import { Link } from "react-router-dom";

import formattedLikesCount from "shared/util/formattedLikesCount";
import Analytics from "analytics/util/Analytics";
import ClientStats from "shared/util/ClientStats";
import Context from "shared/util/Context";
import _str from "shared/util/_str";
import _strf from "shared/util/_strf";
import Masthead from "./Masthead";
import { ROUTES } from "routers/shared/util/consts";

import "./IntoYou.scss";

const QUERY = gql`
	query IntoYouMasthead($userid: String!) {
		user(id: $userid) {
			id
			notificationCounts {
				likesIncoming
			}
		}
	}
`;

const IntoYou = React.forwardRef((_, ref) => {
	const { data, loading } = useQuery(QUERY, {
		variables: {
			userid: Context.get("userid"),
		},
	});
	const incomingLikeCount = get(data, "user.notificationCounts.likesIncoming");

	useEffect(() => { ClientStats.update("masthead - intoyou2 - shown"); }, []);
	const onClose = () => ClientStats.update("masthead - intoyou2 - closed");

	if (loading) {
		return null;
	}

	return (
		<Masthead ref={ref} id="alist_intoyou_masthead" className="header-banner-intoyou opensans" onClose={onClose}>
			<div className="image" />
			<div className="intoyou-text">
				<p>
					<strong>{_strf("$numvotes people like you!", { numvotes: formattedLikesCount(incomingLikeCount) })}</strong>
				</p>
				<p>{_str("See everyone who likes you with A-List.")}</p>
			</div>
			<div>
				<Link
					to={`${ROUTES.Upgrade[0]}?feature=intoyou&cf=desktopbanner`}
					className="link"
					onClick={() => Analytics.Promos.trackLikesYouUpsellHeaderPromo(incomingLikeCount)}
				>
					{_str("Join A-List")}
				</Link>
			</div>
		</Masthead>
	);
});

export default IntoYou;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/IntoYou.jsx